<div class="globalPadding borderDiv">
  <ol class="breadcrumb">
    <li><a href="#" >{{'global.menu.home'|translate}}</a></li>
    <li><a href="#" >{{'global.menu.supportt'|translate}}</a></li>
    <li class="active">App Config</li>
  </ol>
  <div class="col-md-12 noPaddingMd-12 noBottommargin" *ngIf="serverError">
    <div class="alert alert-danger centerText">
      {{'calculator.pensioncalculator.serverError' | translate}}
    </div>
  </div>
  <h3 class="information_faq">{{'appconfig.title'|translate}}</h3>

  <br>

  <button class="btn btn-primary" (click)="openConfigModal()" [hidden]="serverError">
    <span class="glyphicon glyphicon-plus-sign"></span>
    {{'global.button.newconfig' | translate}}
  </button>
  <div class="col-md-12 noPaddingMd-12" [hidden]="serverError">
  <div class="col-md-12">
    <bs-modal id="fundModal" #addConfig cssClass="addConfig" [hidden]="hideModal">
      <bs-modal-header [showDismiss]="true" class="customModalHeader">
        <h4 class="modal-title" id="myAppConfigLabel">Create or edit a Config</h4>

      </bs-modal-header>
      <bs-modal-body>
        <form #passwordForm="ngForm" name="form" novalidate >
          <div class="modal-body">
            <div class="form-group row" >
              <label  class="col-md-2 col-form-label noBottommargin">Key</label>
              <div class="col-md-10 noBottommargin">
                <input class="form-control rightAlign" [disabled]="isUpdate" type="text" class="form-control" [(ngModel)]="appConfig.key" name="configKey">
              </div>
            </div>
            <div class="form-group row" >
              <label  class="col-md-2 col-form-label noBottommargin">SubKey</label>
              <div class="col-md-10 noBottommargin">
                <input class="form-control rightAlign" [disabled]="isUpdate" type="text" class="form-control" [(ngModel)]="appConfig.subKey" name="configSubKey">
              </div>
            </div>
            <div class="form-group row" >
              <label  class="col-md-2 col-form-label noBottommargin">Value</label>
              <div class="col-md-10 noBottommargin">
                <input class="form-control rightAlign"  type="text" class="form-control" [(ngModel)]="appConfig.value" name="configValue">
              </div>
            </div>
            <div class="form-group row">
              <label  class="col-md-2 col-form-label noBottommargin">Description</label>
              <div class="col-md-10 noBottommargin">
                <input class="form-control rightAlign" type="text" class="form-control" [(ngModel)]="appConfig.description" name="configDescription">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-cool" data-dismiss="modal" >
              <span class="glyphicon glyphicon-arrow-left-circle"></span> {{'global.button.cancel' | translate }}
            </button>

            <button type="submit"  class="btn btn-primary" (click)="createConfig()" data-dismiss="modal" >
              <span class="glyphicon glyphicon-ok_circle"></span> {{'global.button.save' | translate }}
            </button>
          </div>
        </form>
      </bs-modal-body>
      <!--<modal-footer [show-default-buttons]="true"></modal-footer>-->
    </bs-modal>
  </div>
    <div class="col-md-12">
      <bs-modal id="deleteModal" #deleteConfig cssClass="deleteConfig" [hidden]="deleteConfirmModal">
        <bs-modal-header [showDismiss]="true" class="customModalHeader">
          <h4 class="modal-title" id="myAppDeleteConfigLabel" >{{'global.messages.confirm.delete' | translate}}</h4>

        </bs-modal-header>
        <bs-modal-body>
          <div class="row">
            <div class="col-lg-1">
              <span class="icons-oneweb-allianz-Icon_Why ico-confirmation status-color"></span>
              <span class="text-confirmation"></span>
            </div>
            <div class="col-lg-11" style="padding-top:3px;">
		                	<span>
		                		{{'appconfig.message.confirm' | translate}}
		                	</span>
            </div>
          </div>

          <div class="modal-footer">

            <button id="cancelBtn" name="cancelBtn" type="button" class="btn btn-cool" data-dismiss="modal" click="clear()">
              <span class="glyphicon glyphicon-remove"></span> {{'global.button.no' | translate }}
            </button>
            <button id="saveBtn" name="confirmYes" class="btn btn-primary" type="submit" (click)="deleteConfirmed(selectedRow)" data-dismiss="modal">
              <span class="glyphicon glyphicon-ok_circle"></span>{{'global.button.yes' | translate }}
            </button>
          </div>
        </bs-modal-body>

      </bs-modal>
    </div>
  <div class="col-md-12 noPaddingMd-12" >
    <div class="alert alert-success alert-dismissable" *ngIf="addSuccess">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <strong>{{message}}</strong>
    </div>
    <div class="alert alert-success alert-dismissable" *ngIf="isDelete">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <strong>{{deleteMessage}}</strong>
    </div>
    <table class="table table-scrollable whiltebg-div">
      <thead class="gray_thead">
      <tr class="gray_thead">
        <!--                     <th>ID</th> -->
        <th>Key</th>
        <th>SubKey</th>
        <th>Value</th>
        <th>Description</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let appConfig of appConfigs;let i = index;">
        <!--                     <td>{{appConfig.id}}</td> -->
        <td style="width:5%;">{{appConfig.key}}</td>
        <td style="width:20%;">{{appConfig.subKey}}</td>
        <td style="width:22%; word-break:inherit;">{{appConfig.value}}</td>
        <td style="width:27%;">{{appConfig.description}}</td>
        <td style="width:27%;">
          <button type="button" class="btn btn-primary btnMain" (click)="editConfig(appConfig)">
            <span class="glyphicon glyphicon-pencil"></span> {{'global.button.edit' | translate}}
          </button>
          <button type="button"
                  class="btn btn-primary btnMain" (click)= "deleteConfigById(appConfig)">
            <span class="glyphicon glyphicon-close-circle"
                  ></span> {{'global.button.delete' | translate}}
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
    </div>
</div>
